<template>
	<p>{{ getCartItemsCount }}</p>
</template>

<script>
export default {
	name: "MiniCart",

	props: [
		'count',
		'items',
		'total_price',
		'subtotal_price'

	],

	created() {

		// Set initial value of cart items in shopping-cart in vuex store...
		this.$store.dispatch('Cart/changeItemCount', this.count);
		this.$store.dispatch('Cart/changeCartItems', this.items);
		this.$store.dispatch('Cart/changeTotalPrice', this.total_price);
		this.$store.dispatch('Cart/changeSubtotalPrice', this.subtotal_price);

	},

	computed: {

		/**
		 * Retrieve cart items from vuex store
		 * That means on every change of vuex state, retrieve changes...
		 */
		getCartItems() {

			return this.$store.getters['Cart/getCartItems'];
		},

		/**
		 * Retrieve cart items count from vuex store
		 */
		getCartItemsCount() {
			return this.$store.getters['Cart/getItemCount'];
		},

		/**
		 * Retrieve cart items total price from vuex store
		 */
		getTotalPrice() {
			return this.$store.getters['Cart/getTotalPrice'];
		},

		/**
		 * Retrieve cart items total price from vuex store
		 */
		getSubtotalPrice() {
			return this.$store.getters['Cart/getSubtotalPrice'];
		},


	},

	/*methods: {
			/!**
			 * Change vuex state to close side cart.
			 *!/
			openSideCart() {
					this.$store.dispatch('Cart/changeSideCart', true);
			}
	}*/

}
</script>
